export default __webpack_public_path__ + "static/media/add_row.653f2e7c.svg";